export default __webpack_public_path__ + "static/media/csod-red-cross.46175388.svg";